import { checkIfEventExists, loadEvents } from './utils/navigation-guards';

const children = [
  {
    name: 'calendar-month',
    path: '',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/Index.vue'),
    },
    meta: { 
      title: 'Agenda',
      showContent: true
    },
    beforeEnter: [loadEvents],
  },
  {
    name: 'calendar-month edit event',
    path: 'edit/:id',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/CalendarDetailColumnEditEvent.vue'),
    },
    meta: { title: 'Agenda', editRecurrence: false },
    beforeEnter: [loadEvents, checkIfEventExists],
  },
  {
    name: 'calendar-month edit recurring event',
    path: 'edit/:id',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/CalendarDetailColumnEditRecurrence.vue'),
    },
    meta: { title: 'Agenda', editRecurrence: true },
    beforeEnter: [loadEvents, checkIfEventExists],
  },
  {
    name: 'calendar-month add event',
    path: 'add',
    components: {
      detailColumn: () => import('@web/pages/calendar/detail-column/CalendarDetailColumnAddPage.vue'),
    },
    meta: { title: 'Agenda' },
    beforeEnter: [loadEvents],
  },
];

export default [
  {
    name: 'calendar-month-view',
    path: '/calendar/month/:year?/:month?/:day?',
    component: () => import('@web/pages/calendar/CalendarMonthView.vue'),
    meta: { title: 'Agenda' },
    redirect: { name: 'calendar-month' },
    children,
  },
];
